 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"betslip-view-chunk":"betslip-view-chunk","casino-sport-book-mobile-chunk.casino-vegas-chunk":"casino-sport-book-mobile-chunk.casino-vegas-chunk","casino-sport-book-mobile-chunk":"casino-sport-book-mobile-chunk","casino-vegas-chunk":"casino-vegas-chunk","charity-chunk":"charity-chunk","chat-chunk":"chat-chunk","chunk-clubnike":"chunk-clubnike","chunk-lottery-ticket":"chunk-lottery-ticket","chunk-nike-tv.turbo-live-chunk":"chunk-nike-tv.turbo-live-chunk","chunk-nike-tv":"chunk-nike-tv","turbo-live-chunk":"turbo-live-chunk","chunk-offices":"chunk-offices","chunk.articleArchive":"chunk.articleArchive","chunk.homepage":"chunk.homepage","chunk.nike-player-iframe":"chunk.nike-player-iframe","chunk.react-query-devtools":"chunk.react-query-devtools","gom-page-chunk":"gom-page-chunk","matchtracker-chunk":"matchtracker-chunk","mymoney-chunk":"mymoney-chunk","mytickets-chunk":"mytickets-chunk","notifications-chunk":"notifications-chunk","promo-cms-chunk":"promo-cms-chunk","reframe-immutablediff":"reframe-immutablediff","self-exclusion-chunk":"self-exclusion-chunk","tournaments-chunk":"tournaments-chunk","vendors.TvNikeCalendar":"vendors.TvNikeCalendar","TvNikeCalendar":"TvNikeCalendar","vendors.chunk-bonusdashboard":"vendors.chunk-bonusdashboard","chunk-bonusdashboard":"chunk-bonusdashboard","vendors.chunk.nike-player-videojs":"vendors.chunk.nike-player-videojs","chunk.nike-player-videojs":"chunk.nike-player-videojs","vendors.chunk.nike-player-youtube":"vendors.chunk.nike-player-youtube","chunk.nike-player-youtube":"chunk.nike-player-youtube","vendors.profile-chunk":"vendors.profile-chunk","profile-chunk":"profile-chunk","virtualGames-chunk":"virtualGames-chunk"}[chunkId]||chunkId) + "." + {"betslip-view-chunk":"6e3cb09d","casino-sport-book-mobile-chunk.casino-vegas-chunk":"49a0918c","casino-sport-book-mobile-chunk":"3563d1b9","casino-vegas-chunk":"1bf8f0a9","charity-chunk":"e5b31373","chat-chunk":"9f62874c","chunk-clubnike":"78356be9","chunk-lottery-ticket":"72c75e91","chunk-nike-tv.turbo-live-chunk":"a4e802e8","chunk-nike-tv":"2b4b2a9e","turbo-live-chunk":"a7ef23f5","chunk-offices":"c56770c6","chunk.articleArchive":"0434a78a","chunk.homepage":"eeb05eba","chunk.nike-player-iframe":"5a65be2a","chunk.react-query-devtools":"fbdf1aba","gom-page-chunk":"5cc2df4d","matchtracker-chunk":"61b99feb","mymoney-chunk":"8a6c4544","mytickets-chunk":"958f4d87","notifications-chunk":"5bc19c7d","promo-cms-chunk":"a71cf028","reframe-immutablediff":"bbc88627","self-exclusion-chunk":"7962c82d","tournaments-chunk":"a536b42f","vendors.TvNikeCalendar":"24184622","TvNikeCalendar":"2a78ce47","vendors.chunk-bonusdashboard":"a1ab2280","chunk-bonusdashboard":"1e7e9643","vendors.chunk.nike-player-videojs":"ad395b03","chunk.nike-player-videojs":"c1502811","vendors.chunk.nike-player-youtube":"0a8110c9","chunk.nike-player-youtube":"9d54b0af","vendors.profile-chunk":"db9cd040","profile-chunk":"7dd5af98","virtualGames-chunk":"d613243d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"betslip-view-chunk":1,"casino-sport-book-mobile-chunk.casino-vegas-chunk":1,"casino-sport-book-mobile-chunk":1,"casino-vegas-chunk":1,"charity-chunk":1,"chat-chunk":1,"chunk-clubnike":1,"chunk-lottery-ticket":1,"chunk-nike-tv.turbo-live-chunk":1,"chunk-nike-tv":1,"turbo-live-chunk":1,"chunk-offices":1,"chunk.articleArchive":1,"chunk.homepage":1,"chunk.nike-player-iframe":1,"gom-page-chunk":1,"matchtracker-chunk":1,"mymoney-chunk":1,"mytickets-chunk":1,"promo-cms-chunk":1,"tournaments-chunk":1,"vendors.TvNikeCalendar":1,"TvNikeCalendar":1,"chunk-bonusdashboard":1,"vendors.chunk.nike-player-videojs":1,"chunk.nike-player-videojs":1,"chunk.nike-player-youtube":1,"profile-chunk":1,"virtualGames-chunk":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"betslip-view-chunk":"betslip-view-chunk","casino-sport-book-mobile-chunk.casino-vegas-chunk":"casino-sport-book-mobile-chunk.casino-vegas-chunk","casino-sport-book-mobile-chunk":"casino-sport-book-mobile-chunk","casino-vegas-chunk":"casino-vegas-chunk","charity-chunk":"charity-chunk","chat-chunk":"chat-chunk","chunk-clubnike":"chunk-clubnike","chunk-lottery-ticket":"chunk-lottery-ticket","chunk-nike-tv.turbo-live-chunk":"chunk-nike-tv.turbo-live-chunk","chunk-nike-tv":"chunk-nike-tv","turbo-live-chunk":"turbo-live-chunk","chunk-offices":"chunk-offices","chunk.articleArchive":"chunk.articleArchive","chunk.homepage":"chunk.homepage","chunk.nike-player-iframe":"chunk.nike-player-iframe","chunk.react-query-devtools":"chunk.react-query-devtools","gom-page-chunk":"gom-page-chunk","matchtracker-chunk":"matchtracker-chunk","mymoney-chunk":"mymoney-chunk","mytickets-chunk":"mytickets-chunk","notifications-chunk":"notifications-chunk","promo-cms-chunk":"promo-cms-chunk","reframe-immutablediff":"reframe-immutablediff","self-exclusion-chunk":"self-exclusion-chunk","tournaments-chunk":"tournaments-chunk","vendors.TvNikeCalendar":"vendors.TvNikeCalendar","TvNikeCalendar":"TvNikeCalendar","vendors.chunk-bonusdashboard":"vendors.chunk-bonusdashboard","chunk-bonusdashboard":"chunk-bonusdashboard","vendors.chunk.nike-player-videojs":"vendors.chunk.nike-player-videojs","chunk.nike-player-videojs":"chunk.nike-player-videojs","vendors.chunk.nike-player-youtube":"vendors.chunk.nike-player-youtube","chunk.nike-player-youtube":"chunk.nike-player-youtube","vendors.profile-chunk":"vendors.profile-chunk","profile-chunk":"profile-chunk","virtualGames-chunk":"virtualGames-chunk"}[chunkId]||chunkId) + "." + {"betslip-view-chunk":"82d2000e","casino-sport-book-mobile-chunk.casino-vegas-chunk":"b5f359c5","casino-sport-book-mobile-chunk":"f9762622","casino-vegas-chunk":"c05651e6","charity-chunk":"4399a034","chat-chunk":"1e319808","chunk-clubnike":"7ad65e62","chunk-lottery-ticket":"7fe8395a","chunk-nike-tv.turbo-live-chunk":"f624f7bf","chunk-nike-tv":"7edaecf8","turbo-live-chunk":"b0673d71","chunk-offices":"1ef947c9","chunk.articleArchive":"7d601fc5","chunk.homepage":"db8f53e3","chunk.nike-player-iframe":"41bf9af7","chunk.react-query-devtools":"31d6cfe0","gom-page-chunk":"88d5c860","matchtracker-chunk":"7d09b50b","mymoney-chunk":"c92b2d3b","mytickets-chunk":"056a1ea6","notifications-chunk":"31d6cfe0","promo-cms-chunk":"1defe298","reframe-immutablediff":"31d6cfe0","self-exclusion-chunk":"31d6cfe0","tournaments-chunk":"f4b926ab","vendors.TvNikeCalendar":"bdbdf991","TvNikeCalendar":"eda92a1d","vendors.chunk-bonusdashboard":"31d6cfe0","chunk-bonusdashboard":"a550a77d","vendors.chunk.nike-player-videojs":"c9e696f2","chunk.nike-player-videojs":"f049cc41","vendors.chunk.nike-player-youtube":"31d6cfe0","chunk.nike-player-youtube":"17663582","vendors.profile-chunk":"31d6cfe0","profile-chunk":"82afab66","virtualGames-chunk":"649f20d7"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "./";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonp"] = this["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
